import React from 'react';
import { Link } from 'react-router-dom';
import useHomeRedirect from 'hooks/useHomeRedirect';

const HomeLink = props => {
  const { getHomePath, logoutAndRedirect } = useHomeRedirect();
  const homePath = getHomePath();

  const handleClick = e => {
    if (!homePath) {
      e.preventDefault();
      logoutAndRedirect();
    }
    if (props.onClick) {
      props.onClick(e);
    }
  };

  return <Link {...props} to={homePath || '#'} onClick={handleClick} />;
};

export default HomeLink;
